<template>
  <div class="inner">
    <el-container>
      <el-header height="20px">
        <el-button v-if="infoForm.authFlag=='00'" type="text" class="fontStyle" style="padding-left: 10px;" @click="personalAuth">
          您好，您的账户未认证，请
          <a>前往认证！</a>
        </el-button>
        <!-- 0：待审核；1：人工审核通过；2：审核拒绝;3:再次审核；4：自动审核通过 -->
        <span v-if="infoForm.authFlag !='00' && (infoForm.auditStatus == '0' || infoForm.auditStatus == null || infoForm.auditStatus == '3')" class="fontStyle" style="padding-left: 10px;">已认证，资料待审核</span>
        <!-- <span v-if="infoForm.authFlag != '00' && (infoForm.auditStatus == '3')" style="padding-left: 10px;">您好：{{ custName }}客户</span> -->
        <span v-if="infoForm.auditStatus == '2'" style="padding-left: 10px;">您的资料未审核通过</span>
        <span v-if="infoForm.authFlag !='00' && (infoForm.auditStatus == '1' || infoForm.auditStatus == '4')" style="padding-left: 10px;">{{ custName }}<a class="fontStyle">已实名</a></span>
      </el-header>
      <!-- <div style="margin:20px 20px 0 20px;" v-if="infoForm.authFlag == '02' || infoForm.authFlag !='00' && (infoForm.auditStatus == '0' || infoForm.auditStatus == '3' || infoForm.auditStatus == '2')"> -->
      <div v-if="infoForm.authFlag !='00'" style="margin:20px 20px 0 20px;">
        <el-button v-for="(item,index) in info" :key="index" :class="{active:index ==num}" :data-id="item.id" @click="tabChange(index)">{{ item.name }}</el-button>
      </div>
      <el-main v-show="num == 0">
        <table width="100%" height="255px" align="center" cellspacing="0" class="tabs-table">
          <tbody>
            <tr>
              <td class="table-left">企业名称</td>
              <td class="table-right">{{ infoForm.companyName }}</td>
              <td class="table-left">客户编号</td>
              <td class="table-right">{{ infoForm.customerCode }}</td>
            </tr>
            <tr>
              <td class="table-left">社会信用代码证</td>
              <td class="table-right">{{ infoForm.tradeLicenseNo }}</td>
              <td class="table-left" />
              <td class="table-right" />
            </tr>
            <tr>
              <td class="table-left">单位所在地</td>
              <td class="table-right">
                {{ infoForm.tradeLicenseProvince+infoForm.tradeLicenseCity+infoForm.tradeLicenseCountie+infoForm.address }}</td>
              <td class="table-left">入网时间</td>
              <td class="table-right">{{ infoForm.createTime }}</td>
            </tr>
            <tr>
              <td class="table-left">成立日期</td>
              <td class="table-right">{{ infoForm.openDate }}
                <el-button type="text" class="buttonStyle" style="padding-left: 10px;" @click="dialogVisibleDate = true">修改</el-button>
              </td>
              <td class="table-left">营业期限</td>
              <td class="table-right">
                <span v-if="infoForm.businessTermValid=='1'">长期</span>
                <span v-if="infoForm.businessTermValid !='1'">{{ infoForm.businessTermFrom + toPath + infoForm.businessTermTo }}</span>
              </td>
            </tr>
            <tr>
              <td class="table-left">法人姓名</td>
              <td class="table-right">{{ infoForm.corporationName }}</td>
              <td class="table-left">证件类型</td>
              <td class="table-right">身份证</td>
            </tr>
            <tr>
              <td class="table-left">法人身份证</td>
              <td class="table-right">{{ infoForm.corporationIdCardNoMask }}</td>
              <td class="table-left">证件有效期</td>
              <td class="table-right">
                <span v-if="infoForm.corporationIdCardTermValid == '1'">长期</span>
                <span v-if="infoForm.corporationIdCardTermValid != '1'">{{ infoForm.corporationIdCardTermFrom + toPathform + infoForm.corporationIdCardTermTo }}</span>
              </td>
            </tr>
            <tr>
              <td class="table-left">联系人姓名</td>
              <td class="table-right">{{ infoForm.contactName }}</td>
              <td class="table-left">联系人手机号</td>
              <td class="table-right">{{ infoForm.contactPhoneMask }}
                <el-button type="text" class="buttonStyle" style="padding-left: 10px;" @click="editPhone">修改</el-button>
              </td>
            </tr>
            <tr v-if="infoForm.orgNo!=null">
              <td class="table-left">收获地址</td>
              <td class="table-right" colspan="3">{{ infoForm.defaultAddress }}
                <el-button type="text" class="buttonStyle" style="padding-left: 10px;" @click="address">管理</el-button></td>
            </tr>
            <tr>
              <td class="table-left">营业执照</td>
              <td v-if="infoForm.enterpriseType !== '2'" class="table-right" colspan="3">
                <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
                <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
                <el-button type="text" class="fontStyle" style="color: #498AEA" @click="uploadUpdate">更新</el-button>
              </td>
            </tr>
            <tr>
              <td class="table-left">法人身份证</td>
              <td class="table-right" colspan="3">
                <span v-if="infoForm.auditStatus == '1' || infoForm.auditStatus == '4'" style="margin-right: 50px;">已上传</span>
                <span v-if="infoForm.auditStatus == '0' || infoForm.auditStatus == '3'" style="margin-right: 50px;">待审核</span>
                <el-button type="text" class="fontStyle" style="color: #498AEA" @click="idCarduploadUpdate">更新</el-button>
              </td>
            </tr>
          </tbody>
        </table>
      </el-main>
      <el-dialog
        title="上传营业执照"
        :visible.sync="licenseUpload"
        width="30%"
        center
      >
        <div class="business">
          <span>营业执照：</span>
          <el-upload
            ref="licenseForm"
            style="display:inline-block;margin-right:15px;"
            action=""
            accept="image/jpeg,image/jpg,image/png"
            :limit="1"
            list-type="picture-card"
            :on-remove="(file) => {licenseHandleRemove(file)}"
            :http-request="(file) => {licenseHandleUpload(file)}"
          >
            <i class="el-icon-plus" />
          </el-upload>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="upload">提交</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="上传证件"
        :visible.sync="dialogVisibleinfo"
        width="30%"
      >
        <el-form
          ref="personalInfoForm"
          :model="personalInfoForm"
          label-width="140px"
          size="small"
        >
          <el-form-item label="身份证正面：">
            <el-upload
              ref="idCardForm"
              style="display:inline-block;margin-right:15px;"
              action=""
              accept="image/jpeg,image/jpg,image/png"
              :limit="1"
              :class="{hide:personZ.hide}"
              list-type="picture-card"
              :on-change="(file, fileList) => {handleChangeByPersonal(file, fileList2,personZ)}"
              :on-remove="(file, fileList) => {frontHandleRemoveByPersonal(file, fileList2,personZ)}"
              :http-request="(file, fileList) => {UploadByPersonal(file, fileList2,personZ)}"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
          <el-form-item label="身份证反面：">
            <el-upload
              ref="idCardFormlist"
              class="upload-demo"
              style="display:inline-block;margin-right:15px;"
              action=""
              accept="image/jpeg,image/jpg,image/png"
              :limit="1"
              :class="{hide:personZ.hide}"
              list-type="picture-card"
              :on-change="(file, fileList) => {handleChangeByPersonal(file, fileList2,personZ)}"
              :on-remove="(file, fileList) => {backHandleRemoveByPersonal(file, fileList2,personZ)}"
              :http-request="(file, fileList) => {backHandlePersonal(file, fileList2,personZ)}"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="suBmitPersonal">提交</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="更新成立日期"
        :visible.sync="dialogVisibleDate"
        width="40%"
        @close="closeDate"
      >
        <el-form
          ref="personalDateForm"
          :model="personalDateForm"
          label-width="140px"
          size="small"
          :rules="personalDateRules"
        >
          <el-form-item label="成立日期：" prop="openDate">
            <el-date-picker
              v-model="personalDateForm.openDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="updateDate">提交</el-button>
        </span>
      </el-dialog>
      <el-main v-show="num == 1">
        <Enterprise v-if="customerType ==='8' && infoForm.enterpriseType === '0'" />
        <Individual v-if="customerType ==='8' && infoForm.enterpriseType === '1'" />
        <PersonalEnter v-if="customerType ==='8' && infoForm.enterpriseType === '2'" />
      </el-main>
    </el-container>
    <!-- 证件有效期 -->
    <el-dialog :visible.sync="isAuthOverdue" :show-close="!isAuthOverdueFlag" :close-on-click-modal="!isAuthOverdueFlag" :close-on-press-escape="!isAuthOverdueFlag" width="25%">
      <div class="rztext">
        <div>{{ authOverdueDesc }}</div>
      </div>
      <div slot="footer" style="text-align: center;">
        <!-- <el-button v-if="!isAuthOverdueFlag" @click="isAuthOverdue = false">已更新</el-button> -->
        <el-button type="primary" @click="updateValdy">去更新</el-button>
      </div>
    </el-dialog>
    <!-- 补全信息 -->
    <el-dialog :visible.sync="isOtherOverdue" :show-close="!isOtherOverdueFlag" :close-on-click-modal="!isOtherOverdueFlag" :close-on-press-escape="!isOtherOverdueFlag" width="25%">
      <div class="rztext">
        <div>{{ otherOverdueDesc }}</div>
      </div>
      <div slot="footer" style="text-align: center;">
        <!-- <el-button v-if="!isOtherOverdueFlag" @click="isOtherOverdue = false">已更新</el-button> -->
        <el-button type="primary" @click="Tosupplement">去更新</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCompanyInfo, customerUpdate, updateOpendate, overdueRemind } from '@/api/info'
import { getArea } from '@/api/common/common'
import store from '@/store'
import Session from '@/utils/session'
import Enterprise from '@/components/enterprise'
import Individual from '@/components/individual'
import PersonalEnter from '@/components/personalEnter'
import File from '@/utils/file'
import compress from '@/utils/compress'
import imgSize from '@/utils/imgSize'
export default {
  components: {
    Enterprise,
    Individual,
    PersonalEnter
  },
  data() {
    return {
      isAuthOverdueFlag: false,
      isOtherOverdueFlag: false,
      isAuthOverdue: false,
      authOverdueDesc: null,
      isOtherOverdue: false,
      otherOverdueDesc: null,
      customerNo: Session.getItem('customerId'),
      custName: Session.getItem('customerName'),
      dialogVisibleinfo: false,
      licenseUpload: false,
      fileList2: [],
      toPath: '至',
      toPathform: '到',
      info: [
        {
          name: '基本信息',
          id: 1
        },
        {
          name: '其他信息',
          id: 2
        }
      ],
      // 省
      provinceArray: [],
      cityArray: [],
      countyArray: [],
      personalInfoForm: {
        customerId: store.getters.customerId,
        corporationIdCardUrlFront: null,
        corporationIdCardUrlBack: null,
        editFlag: 1,
        // 身份证
        idCard: null,
        // 身份证
        idCardUrlFront: null,
        // 身份证
        idCardUrlBack: null,
        // 绑定手机
        phoneMask: Session.getItem('phoneMask'),
        // 所在省
        personProv: null,
        // 所在省编号
        personProvNo: null,
        // 所在市
        personCity: null,
        // 所在市编号
        personCityNo: null,
        // 所在县区
        personCounties: null,
        // 所在县区编号
        personCountiesNo: null,
        // 地址
        address: null,
        // 是否跨境 0-非跨境 1-跨境
        crossBorderFlag: '0',
        // 币种
        ccy: 'CNY',
        // 证件类型1：身份证；2：其他
        corporationIdCardType: '1',
        // 操作人-手机号
        openUserId: Session.getItem('phone')
      },
      num: 0,
      personZ: {
        hide: false,
        flagUrl: 'personFrontUrl'
      },
      infoForm: {
        // 18684359154364416
        customerId: store.getters.customerId,
        enterpriseType: null,
        editFlag: 1,
        // 企业名称
        companyName: null,
        // 营业执照文件存放code
        tradeLicenseUrl: null,
        // 客户编号
        customerCode: null,
        // 统一信用代码
        tradeLicenseNo: null,
        // 所在省
        tradeLicenseProvince: null,
        // 所在市
        tradeLicenseCity: null,
        // 所在县区
        tradeLicenseCountie: null,
        // 详细地址
        address: null,
        // 成立日期
        openDate: null,
        // 入网时间
        createTime: null,
        // 经营时限开始
        businessTermFrom: '',
        // 经营时限结束
        businessTermTo: '',
        // 经营期限至-长期标志 1：长期；0：非长期
        businessTermValid: null,
        // 法人姓名
        corporationName: null,
        // 法人身份证
        corporationIdCardNo: null,
        // 法人身份证mask
        corporationIdCardNoMask: null,
        // 联系人姓名
        contactName: null,
        // 联系人手机号
        contactPhone: null,
        // 联系人手机号mask
        contactPhoneMask: null,
        // 营业执照img
        licenseImg: null,
        // 身份证正面img
        idCardFrontImg: null,
        // 身份证反面img
        idCardBackImg: null,
        // 收货地址
        defaultAddress: null,
        // 客户机构号
        orgNo: null,
        occupation: null,
        national: null,
        sex: null,
        // 实名认证标志 （00-临时,01-弱实名,02-强实名）
        authFlag: null,
        tradeLicenseProvinceNo: null,
        tradeLicenseCityNo: null,
        tradeLicenseCountieNo: null,
        auditStatus: null
      },
      customerType: Session.getItem('customerType'),
      dialogVisibleDate: false,
      personalDateForm: {
        openDate: null
      },
      personalDateRules: {
        openDate: [
          { required: true, message: '请选择日期', trigger: 'blur' }
        ]
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'personalInfo' && to.name !== 'customerInfo') {
      this.overdueRemind().then(response => {
        if (response.data.authOverdueFlag === '2') {
          this.isAuthOverdue = true
        } else {
          this.isAuthOverdue = false
        }
        this.authOverdueDesc = response.data.authOverdueDesc
        if (response.data.otherOverdueFlag === '2') {
          this.isOtherOverdue = true
        } else {
          this.isOtherOverdue = false
        }
        this.otherOverdueDesc = response.data.otherOverdueDesc
        if (!this.isAuthOverdue && !this.isOtherOverdue) {
          next()
        }
      })
    } else {
      next()
    }
  },
  watch: {
    $route() {
      if (this.$route.name === 'enterpriseInfo') {
        this.getData()
      }
    },
    authOverdueFlag(val) {
      if (val === '2') {
        this.isAuthOverdueFlag = true
      }
    },
    otherOverdueFlag(val) {
      if (val === '2') {
        this.isOtherOverdueFlag = true
      }
    }
  },
  created() {
    this.getData()
    this.getArea()
  },
  methods: {
    // 更新
    updateValdy() {
      this.isAuthOverdue = false
    },
    // 去更新
    Tosupplement() {
      this.isOtherOverdue = false
    },
    // 客户过期时间提醒
    overdueRemind() {
      const param = {
        customerId: this.customerNo,
        customerType: this.customerType
      }
      return new Promise(function(resolve, reject) {
        overdueRemind(param).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    idCarduploadUpdate() {
      this.$message.error('请通过dopay或小金管控APP进行更新资料！')
      // this.dialogVisibleinfo = true
    },
    // 上传身份证正面图片
    UploadByPersonal(data, fileList, item) {
      const file = data.file
      imgSize(file).then(() => {
        compress(file, 100).then((res) => {
          const form = new FormData()
          form.set('file', res)
          File.upload(form)
            .then(response => {
              this.personalInfoForm.corporationIdCardUrlFront = response.data.code
            })
            .catch(error => {
              console.error(error)
            })
        })
      }).catch(() => {})
      // const form = new FormData()
      // form.append('file', file)
      // File.upload(form)
      //   .then(response => {
      //     this.personalInfoForm.corporationIdCardUrlFront = response.data.code
      //   })
      //   .catch(error => {
      //     console.error(error)
      //   })
    },
    // 上传身份证反面图片
    backHandlePersonal(data, fileList, item) {
      const file = data.file
      imgSize(file).then(() => {
        compress(file, 100).then((res) => {
          const form = new FormData()
          form.set('file', res)
          File.upload(form)
            .then(response => {
              this.personalInfoForm.corporationIdCardUrlBack = response.data.code
            })
            .catch(error => {
              console.error(error)
            })
        })
      }).catch(() => {})
      // const form = new FormData()
      // form.append('file', file)
      // File.upload(form)
      //   .then(response => {
      //     this.personalInfoForm.corporationIdCardUrlBack = response.data.code
      //   })
      //   .catch(error => {
      //     console.error(error)
      //   })
    },
    // 图片删除事件
    frontHandleRemoveByPersonal(file, fileList, item) {
      this.personalInfoForm.corporationIdCardUrlFront = null
    },
    // 图片删除事件
    backHandleRemoveByPersonal(file, fileList, item) {
      this.personalInfoForm.corporationIdCardUrlBack = null
    },
    // 提交证件
    suBmitPersonal() {
      const param = {
        editFlag: 1,
        customerId: store.getters.customerId,
        corporationIdCardUrlFront: this.personalInfoForm.corporationIdCardUrlFront,
        corporationIdCardUrlBack: this.personalInfoForm.corporationIdCardUrlBack,
        isOverDue: true
      }
      customerUpdate(param).then(res => {
        this.$message.success(res.message)
        this.$refs['idCardForm'].clearFiles()
        this.$refs['idCardFormlist'].clearFiles()
        this.dialogVisibleinfo = false
      }).catch(error => {
        this.$message.error(error)
        this.$refs['idCardForm'].clearFiles()
        this.$refs['idCardFormlist'].clearFiles()
        this.dialogVisibleinfo = false
      })
    },
    // 更新成立日期
    updateDate() {
      this.$refs.personalDateForm.validate((valid) => {
        if (valid) {
          const param = {
            code: this.infoForm.customerCode,
            openDate: this.personalDateForm.openDate
          }
          updateOpendate(param).then(res => {
            this.$message.success(res.message)
            this.dialogVisibleDate = false
            this.getData()
          }).catch(error => {
            this.$message.error(error)
            this.dialogVisibleDate = false
          })
        }
      })
    },
    closeDate() {
      this.personalDateForm.openDate = null
    },
    // 营业执照更新
    uploadUpdate() {
      this.$message.error('请通过dopay或小金管控APP进行更新资料！')
      // this.licenseUpload = true
    },
    // 图片删除事件
    licenseHandleRemove(file) {
      this.infoForm.tradeLicenseUrl = null
    },
    // 上传营业执照
    licenseHandleUpload(data) {
      const file = data.file
      imgSize(file).then(() => {
        compress(file, 100).then((res) => {
          const form = new FormData()
          form.set('file', res)
          File.upload(form)
            .then(response => {
              this.infoForm.tradeLicenseUrl = response.data.code
            })
            .catch(error => {
              console.error(error)
            })
        })
      }).catch(() => {})
      // const form = new FormData()
      // form.append('file', file)
      // File.upload(form)
      //   .then(response => {
      //     this.infoForm.tradeLicenseUrl = response.data.code
      //   })
      //   .catch(error => {
      //     console.error(error)
      //   })
    },
    // 上传
    upload() {
      const param = {
        editFlag: 1,
        customerId: store.getters.customerId,
        isOverDue: true,
        tradeLicenseUrl: this.infoForm.tradeLicenseUrl
      }
      customerUpdate(param).then(res => {
        this.$message.success(res.message)
        this.$refs['licenseForm'].clearFiles()
        this.licenseUpload = false
      }).catch(error => {
        this.$message.error(error)
        this.$refs['licenseForm'].clearFiles()
        this.licenseUpload = false
      })
    },
    // 获取省
    getArea() {
      const param = {}
      getArea(param)
        .then(res => {
          this.provinceArray = res.data.children
        })
        .catch(error => {
          // 捕获异常
          console.log(error)
        })
    },
    // 注册地址市
    getCityData(val) {
      this.cityArray = []
      this.countyArray = []
      this.infoForm.tradeLicenseCity = null
      this.infoForm.tradeLicenseCityNo = null
      this.infoForm.tradeLicenseCountie = null
      this.infoForm.tradeLicenseCountieNo = null
      this.infoForm.tradeLicenseProvinceNo = val
      for (const item of this.provinceArray) {
        if (item.id === val) {
          this.infoForm.tradeLicenseProvince = item.name
        }
      }
      if (val > 0) {
        const param = {
          id: val
        }
        return new Promise((resolve, reject) => {
          getArea(param)
            .then(res => {
              this.cityArray = res.data.children
              resolve(this.cityArray)
            })
            .catch(error => {
              reject(error)
              console.log(error) // 捕获异常
            })
        })
      }
    },
    // 注册县
    getCountyData(val) {
      this.countyArray = []
      this.infoForm.tradeLicenseCountie = null
      this.infoForm.tradeLicenseCountieNo = null
      this.infoForm.tradeLicenseCityNo = val
      for (const item of this.cityArray) {
        if (item.id === val) {
          this.infoForm.tradeLicenseCity = item.name
        }
      }
      if (val > 0) {
        const param = {
          id: val
        }
        return new Promise((resolve, reject) => {
          getArea(param)
            .then(res => {
              this.countyArray = res.data.children
              resolve(this.countyArray)
            })
            .catch(error => {
              console.log(error) // 捕获异常
              reject(error)
            })
        })
      }
    },
    // 注册区事件
    changeCountyData(val) {
      this.infoForm.tradeLicenseCountieNo = val
      for (const item of this.countyArray) {
        if (item.id === val) {
          this.infoForm.tradeLicenseCountie = item.name
        }
      }
    },
    // 图片上传change事件
    handleChangeByPersonal(file, fileList, item) {
      console.log(fileList)
      console.log(fileList.length)
      if (fileList.length >= 1) {
        item.hide = true
      }
      console.log(item.hide)
    },
    // 点击切换
    tabChange(index) {
      this.num = index
    },
    // 查询
    getData() {
      const param = {
        customerId: this.infoForm.customerId
      }
      getCompanyInfo(param)
        .then(res => {
          this.infoForm = Object.assign({}, res.data)
          if (res.data.businessTermFrom == null && res.data.businessTermTo != null) {
            this.toPath = ''
            this.infoForm.businessTermFrom = ''
          } else if (res.data.businessTermTo == null && res.data.businessTermFrom != null) {
            this.toPath = ''
            this.infoForm.businessTermTo = ''
          } else if (res.data.businessTermFrom == null && res.data.businessTermTo == null) {
            this.toPath = ''
            this.infoForm.businessTermFrom = ''
            this.infoForm.businessTermTo = ''
          } else if (res.data.businessTermFrom != null && res.data.businessTermTo != null) {
            this.toPath = '至'
            this.infoForm.businessTermFrom = res.data.businessTermFrom
            this.infoForm.businessTermTo = res.data.businessTermTo
          }
          if (res.data.corporationIdCardTermFrom == null && res.data.corporationIdCardTermTo != null) {
            this.toPathform = ''
            this.infoForm.corporationIdCardTermFrom = ''
          } else if (res.data.corporationIdCardTermTo == null && res.data.corporationIdCardTermFrom != null) {
            this.toPathform = ''
            this.infoForm.corporationIdCardTermTo = ''
          } else if (res.data.corporationIdCardTermFrom == null && res.data.corporationIdCardTermTo == null) {
            this.toPathform = ''
            this.infoForm.corporationIdCardTermFrom = ''
            this.infoForm.corporationIdCardTermTo = ''
          } else if (res.data.corporationIdCardTermFrom != null && res.data.corporationIdCardTermTo != null) {
            this.toPathform = '到'
            this.infoForm.corporationIdCardTermFrom = res.data.corporationIdCardTermFrom
            this.infoForm.corporationIdCardTermTo = res.data.corporationIdCardTermTo
          }
          // 营业执照img
          if (res.data.tradeLicense) {
            this.infoForm.licenseImg = res.data.tradeLicense.url
          } else {
            this.infoForm.licenseImg = ''
          }
          // 身份证正面img
          if (res.data.idCardFront) {
            this.infoForm.idCardFrontImg = res.data.idCardFront.url
          } else {
            this.infoForm.idCardFrontImg = ''
          }
          // 身份证反面img
          if (res.data.idCardBack) {
            this.infoForm.idCardBackImg = res.data.idCardBack.url
          } else {
            this.infoForm.idCardBackImg = ''
          }
        })
        .catch(error => {
          console.log(error) // 请求失败返回的数据
        })
    },
    // 实名认证
    personalAuth() {
      this.$router.push({
        name: 'companyAuth'
      })
    },
    // 管理收货地址
    address() {
      this.$router.push({
        name: 'manageAddress',
        params: {
          orgId: this.infoForm.orgNo
        }
      })
    },
    // 修改手机号
    editPhone() {
      this.$router.push({
        name: 'editPhone'
      })
    }
  }
}
</script>

<style scoped>
.inner {
  padding: 35px;
}
.tabs-table {
  padding: 0;
  border: solid #ccc;
  border-width: 1px 0px 0px 1px;
}
.tabs-table tr {
  height: 40px;
}
.table-left {
  background: #f4f4f6;
  padding-left: 23px;
  font-size: 12px;
  color: #5e5e5e;
  width: 138px;
  border-right: solid #d8d8d8;
  border-width: 0px 1px 1px 0px;
}
.table-right {
  color: #333;
  font-size: 12px;
  padding-left: 23px;
  border: solid #d8d8d8;
  border-width: 0px 1px 1px 0px;
}
.fontStyle {
  width: 42px;
  height: 19px;
  margin-left: 12px;
  font-size: 14px;
  color: #DE201D;
  line-height: 19px;
}
.fontStyle a{
    color: #498AEA;
    text-decoration:underline;
}
.add{
  background-color: #258FFA;color: #fff;border: 1px solid #258FFA;
}
.submit{
  margin: 20px auto;
  display: flex;
}
.visible{
  margin-left: 50px;
}
.left{
  border-bottom: 1px solid #ccc;
}
.active{
  background-color: #498AEA;
  color: #fff;
  border: 1px solid #498AEA;
}
.addeas .el-form-item{
  margin-bottom: 0px;
}
.table-right{
  width: 300px;
}
.business{
  display: flex;
  align-items: center;
}
.a{
  color: #498AEA;
  text-decoration:underline;
}
</style>
